import lodash from 'lodash'
import React, { ReactElement, useMemo } from 'react'
import styled from 'styled-components'

import DecimalInput from '../../../../../../../1stlog-ui/src/components/DecimalInput'
import Field, {
  useField,
  useFieldContext,
} from '../../../../../../../1stlog-ui/src/components/Field'
import useFieldValue from '../../../../../../../1stlog-ui/src/components/Field/useFieldValue'
import {
  composeValidators,
  mustBeNumber,
  required,
} from '../../../../../../../1stlog-ui/src/components/Field/Validation'

const Wrapper = styled.div``

const ExplosiveMass = (): ReactElement => {
  const { prefix = '' } = useFieldContext()

  const transportCategory = useField('transportCategory')
  const limitedQuantityEnabled = useFieldValue('limitedQuantityEnabled')

  const isRequired = useMemo(
    () => limitedQuantityEnabled === false || String(transportCategory) === '1',
    [transportCategory, limitedQuantityEnabled],
  )

  return (
    <Wrapper>
      <Field
        key={[transportCategory, limitedQuantityEnabled].join('_')}
        name="explosiveMass"
        label={`${i18n.t('explosive_mass', 'Explosive Masse')} (kg)`}
        validate={composeValidators(
          isRequired ? required : undefined,
          isRequired ? mustBeNumber : undefined,
          mustBeWithinWeight(prefix),
        )}
        required={isRequired}
      >
        <DecimalInput
          placeholder={i18n.t('in_kg', 'In kg angeben')}
          minimumFractionDigits={2}
        />
      </Field>
    </Wrapper>
  )
}

export default ExplosiveMass

function mustBeWithinWeight(
  name: string,
): (explosiveMass: any, allValues: any) => string | undefined {
  return (explosiveMass, allValues) => {
    const weight = lodash.get(allValues, `${name}.amount`)
    if (Number(explosiveMass) > Number(weight)) {
      return i18n.t(
        'explosive_mass_greater_than_weight_validation',
        'Explosive Masse darf nicht größer als das Gefahrgutgewicht sein',
      )
    }
    return undefined
  }
}
